// extracted by mini-css-extract-plugin
export default {"container":"RA-z","dimension":"SA-z","dimensionLabels":"TA-z"};